// extracted by mini-css-extract-plugin
export default {"card_section":"whyChooseUsCard_card_section__gfDCx","icon":"whyChooseUsCard_icon__P5LlN","title":"whyChooseUsCard_title__ixVFu","details":"whyChooseUsCard_details__qlQRb"};